// extracted by mini-css-extract-plugin
export var printerCard = "_ag-1";
export var printerCardConfigured = "_ag-2";
export var printerCardError = "_ag-3";
export var printerCardsContainer = "_ag-0";
export var printerIcon = "_ag-8";
export var printerIconConfigured = "_ag-5";
export var printerIconContainer = "_ag-4";
export var printerIconError = "_ag-6";
export var printerIconUnconfigured = "_ag-7";